<app-loading *ngIf="isLoading"></app-loading>

<div *ngIf="!isLoading" class="compare-group-detail">
  <h1 class="compare-group-page-title">
    <ng-container *ngIf="isEditing">Edit Self Compare Benchmark</ng-container>
    <ng-container *ngIf="!isEditing">Create Self Compare Benchmark</ng-container>
  </h1>
  <div class="control-bar">
    <div class="control-bar-row">
      <div class="control-group-name">
        <span>
          Benchmark Name: <input 
                                type="text"
                                class="control-group-name"
                                [ngClass]="{'control-group-name-warning': noNameGiven === true}"
                                [(ngModel)]="compareGroupDescription"
                                placeholder="Enter Benchmark Name"
                                (ngModelChange)="isDirty = true"
                                (focus)="onCompareGroupInputFocus()"
                                maxlength="250" 
                              />
        </span>
        <button mat-stroked-button color="primary" class="left-button" (click)="onSave(false)">
          <ng-container *ngIf="isEditing">Update</ng-container>
          <ng-container *ngIf="!isEditing">Create</ng-container>
        </button>
      </div>
      <button *ngIf="isEditing" mat-stroked-button color="primary" class="left-button" (click)="onSave(true)">
        Save As New
      </button>
      <button mat-stroked-button color="primary" class="right-button" (click)="onReturn()">Back</button>
    </div>

    <div class="control-bar-row">
      <mat-form-field class="search-field">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search..." appearance="outline">
        <button mat-button matPrefix>
          <mat-icon class="search-hourglass">search</mat-icon>
        </button>
      </mat-form-field>

      <button mat-stroked-button color="primary" class="right-button" (click)="showSelected = !showSelected">
        <ng-container *ngIf="!showSelected">Show Selected Cohorts</ng-container>
        <ng-container *ngIf="showSelected">Hide Selected Cohorts</ng-container>
      </button>
    </div>
  </div>

  <div class="compare-list-container">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="compareGroupMember">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="select-all-container">
            <mat-checkbox (click)=onSelectAll($event)></mat-checkbox>
            <span style="margin-left: 5px;">{{ rowToName('compareGroupMember') }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox 
            [(ngModel)]="row.compareGroupMember" 
            [checked]="row.compareGroupMember"
            (change)="updateGroupMembers()"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="batchName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('batchName') }}</th>
        <td mat-cell class="org-name-column" *matCellDef="let row"> {{ row.batchName | date:'M/d/yyyy' }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>

      <tr mat-row *matRowDef="
        let row;
        let even = even
        columns: getDisplayedColumns();"
        [ngClass]="{grayRow: even}"
      ></tr>

    </table>

    <!-- <mat-paginator
      [length]="paginationLength"
      [pageSize]="paginationSize"
      [pageSizeOptions]="paginationSizeOptions"
    ></mat-paginator> -->

    <app-no-data 
      *ngIf="isListEmpty" 
      noDataTitle="There are no data to show"
      noDataSubTitle="There are no cohorts for your selected organization"
    ></app-no-data>
  </div>

  <div *ngIf="showSelected">
    <div class="screen-overlay" (click)="showSelected = !showSelected"></div>
    <div class="overlay-container">

      <div class="selected-list-title">
        <span>Selected Cohorts</span>
        <span>
          <mat-icon (click)="showSelected = !showSelected">close</mat-icon>
        </span>
      </div>

      <ng-template *ngIf="getSelectedMembers().length > 0; then membersExist; else listEmpty"></ng-template>

      <ng-template #membersExist>
        <div class="selected-list">
          <mat-selection-list #selectedMembers>
            <mat-list-option 
              *ngFor="let selected of getSelectedMembers(); let even = even;"
              checkboxPosition="before"
              value="{{selected.batchId}}"
              [ngClass]="{grayRow: even}"
              [selected]="true"
            >
              {{selected.batchName | date:'M/d/yyyy'}}
            </mat-list-option>
          </mat-selection-list>
        </div>

        <div class="selected-list-footer">
          <button mat-stroked-button color="primary" (click)="showSelected = !showSelected" class="selected-list-button">Close</button>
          <button mat-stroked-button color="primary" (click)="removeUnselected(selectedMembers.selectedOptions.selected)" class="selected-list-button">Update Selected List</button>
        </div>
      </ng-template>

      <ng-template #listEmpty>
        <div class="selected-list-empty">There are no cohorts selected.</div>

        <div class="selected-list-footer">
          <button mat-stroked-button color="primary" (click)="showSelected = !showSelected" class="selected-list-button">Close</button>
        </div>
      </ng-template>
    </div>
  </div>
  <app-alert 
    *ngIf="showAlert" 
    header="Notice" 
    message="{{alertMessage}}" 
    (closeAlert)="closeAlert()"
    [confirm]="alertIsConfirm" 
    (alertConfirm)="alertConfirm($event)"
  ></app-alert>
</div>